import clsx from 'clsx';
import TextDefault from '../texts/TextDefault';
import { IconInfo } from '../icons/IconInfo';
import { useSteleBreakpoint } from '@/src/hooks/useBreakpoint';

type StatElementProps = {
    title: string;
    value: string | number;
    center?: boolean;
    icon?: string;
    onClick?: () => void;
    hasInfo?: boolean;
}

export default function StatElement({ title, value, center, icon, onClick, hasInfo }: StatElementProps) {
    const isStele = useSteleBreakpoint();
    return (
        <button onClick={hasInfo ? onClick : undefined}
            className={clsx(
                'flex flex-col justify-center w-full',
                'gap-2 | stele:gap-8',
                center ? 'items-center' : 'items-start'
            )}
        >
            <div className='pl-1 stele:pl-4'>
                <TextDefault
                    fontSize={isStele ? 48 : 12}
                    outlineColor='#0A2897'
                    dropShadowColor='#0A2897'
                    leading={1}
                    fontWeight='700'
                >
                    {title}
                </TextDefault>
            </div>
            <div className={clsx(
                'relative flex justify-center items-center bg-white-gradient rounded-full w-full min-w-28.5 stat-container',
                'h-6 stele:h-24 stele:min-w-114'
            )}>
                <p
                    className={clsx(
                        'font-nunito font-black text-gradient-stats leading-[100%]',
                        'text-[16px]',
                        'stele:text-[64px]'
                    )}
                >
                    {value}
                </p>
                {hasInfo &&
                    <div
                        onClick={onClick}
                        className={clsx(
                            'absolute flex justify-center items-center',
                            'left-2 w-4 h-4',
                            'stele:left-8 stele:w-16 stele:h-16'
                        )}
                    >
                        {onClick && <IconInfo width='100%' height='100%' />}</div>
                }
                {icon &&
                    <img
                        src={icon}
                        alt='decorative icon'
                        className={clsx(
                            'z-10 absolute',
                            '-right-4 max-w-14 max-h-14',
                            'stele:-right-16 stele:max-w-56 stele:max-h-56'
                        )}
                    />
                }
            </div>
        </button>
    )
}